export default {
  namespaced: true,
  state: {
    timeHistory: '', //记录当前加载的时间点
    cityName: '四川省',
    Maplevel: 0,
    dataType: 2, // 记录当前选中得数据类型
    timeRange: [String(new Date().getFullYear()) - 1, 0], // 记录用户选择年份
    isLower: false, // 是否是下层数据
    lowerLevelData: {},
    glanceType: undefined, // 数据概览选中类型
    mapIconTotle:[], //地图聚合撒点
    screenMaplevel: 0, //全流程溯源大屏地图层级
  },
  mutations: {
    changeMapIconTotle(state, data) {
      state.mapIconTotle = data;
    },
    changeDataType(state, data) {
      state.dataType = data;
    },
    changeLowerLevelData(state, data) {
      state.lowerLevelData = data;
    },
    changeGlanceType(state, data) {
      state.glanceType = data;
    },
    changeTimeRange(state, data) {
      state.timeRange = data;
    },
    changeIsLower(state, data) {
      state.isLower = data;
    },
    changeMapLevel(state, data) {
      state.Maplevel = data
    },
    SET_MAP_LEVEL(state, data) {
      state.screenMaplevel = data
    }
  },
  action: {},
  getter: {},
};
